
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CartItem } from '@/services/cart/model/cart';
import UnavailableItem from '@/cart-page/cart/section/unavailable/UnavailableItem.vue';
import { DependencyService } from '@/services/DependencyService';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component({
  components: { UnavailableItem }
})
export default class UnavailableProductSection extends Vue {
  @Prop({ required: true, default: [] })
  private items: CartItem[];

  private cartService = DependencyService.getCartService();

  private removeAllUnavailable() {
    MatomoEvents.forCartPage.removeItem.publish();
    this.items.forEach((item) => this.cartService.removeItem(item));
  }
}
